import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Shrimp from '../../../svg/Shrimp.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';
import MailChimp from '../../../helpers/mailchimp';

class OutOfArea extends Component {
  state = {
    email: '',
    isValid: false,
    showSubmitMessage: false
  };
  render() {
    const { email, isValid, showSubmitMessage } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Thank you for your interest."
          subline="Unfortunately, we don’t have chefs in your area just yet. Please share your email so we can let you know when chefs become available in your area."
          icon={<Shrimp />}
        />
        <Formsy
          onValid={this.handleOnValid}
          onInvalid={this.handleOnInvalid}
          onValidSubmit={this.handleSubmit}
          className="onboarding-new__list-signup-form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="email"
                placeholder="Enter your email"
                value={email}
                onChange={this.handleChange}
                showError={false}
                autoComplete="off"
                validations="isEmail"
                required
              />
              {showSubmitMessage && (
                <p className="onboarding-new__submit-message">Thank you!</p>
              )}
            </div>
          </div>
          <input
            type="submit"
            className="new-btn new-btn--solid-green new-btn--full-width onboarding-new__list-button"
            value="Join Our List"
            disabled={!isValid}
          />
        </Formsy>
        <a
          className="onboarding-new__link--blue"
          href="https://www.theculinistas.com/"
        >
          BACK TO HOMEPAGE
        </a>
      </React.Fragment>
    );
  }

  handleSubmit = () => {
    MailChimp.subscribe(this.state.client.email, 'OUT_OF_SERVICE_ZIP_CODE');
    this.setState({ email: '', isValid: false, showSubmitMessage: true });
    setTimeout(() => {
      this.setState({ showSubmitMessage: false });
    }, 3000);
  };

  handleOnValid = () => {
    this.setState({ isValid: true });
  };

  handleOnInvalid = () => {
    this.setState({ isValid: false });
  };

  handleChange = e => {
    const { name, value } = e.target;

    this.setState({ [name]: value });
  };
}

export default OutOfArea;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/OutOfArea.js